import {email, helpers, minLength, required} from '@vuelidate/validators';
import {errors} from "@/config/messages";

const number = helpers.regex(
    /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/
)

export const validations = {
    base: {
        required: (text) => helpers.withMessage(text, required),
        minLength: (text, min) => helpers.withMessage(({ $params}) => text, minLength(min))
    },
    email: {
        email: (text) => helpers.withMessage(text, email),
    },
    phone: {
        number: (text) => helpers.withMessage(({ $params}) => text, number)
    }
}

export const bannerValidationOptions = {
    firstName: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
        minLength: validations.base.minLength(
            window['form-errors']?.minLength.text || errors.minLength.text,
            window['form-errors']?.minLength.length || errors.minLength.length
        )
    },
    lastName: {
        minLength: validations.base.minLength(
            window['form-errors']?.minLength.text || errors.minLength.text,
            window['form-errors']?.minLength.length || errors.minLength.length
        )
    },
    email: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
        email: validations.email.email(window['form-errors']?.email || errors.email)
    },
    phone: {
        number: validations.phone.number(window['form-errors']?.phone || errors.phone),
    },
    company: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
    },
    city: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
    }
}

export const contactUsValidationOptions = {
    firstName: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
        minLength: validations.base.minLength(
            window['form-errors']?.minLength.text || errors.minLength.text,
            window['form-errors']?.minLength.length || errors.minLength.length
        )
    },
    lastName: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
        minLength: validations.base.minLength(
            window['form-errors']?.minLength.text || errors.minLength.text,
            window['form-errors']?.minLength.length || errors.minLength.length
        )
    },
    email: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
        email: validations.email.email(window['form-errors']?.email || errors.email)
    },
    company: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
        minLength: validations.base.minLength(
            window['form-errors']?.minLength.text || errors.minLength.text,
            window['form-errors']?.minLength.length || errors.minLength.length
        )
    },
    industry: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
    },
    city: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
    },
    state: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
    },
    country: {
        required: validations.base.required(window['form-errors']?.empty || errors.empty),
    },
    phone: {
        number: validations.phone.number(window['form-errors']?.phone || errors.phone),
    },
}

export const defineFormError = (v$) => {
    const errors = [];
    const emailPrefix = v$.email.$errors[0]?.$message.split(' ')[0].toLowerCase() === 'invalid'
    const emailError = v$.email.$errors[0]?.$message

    if(v$.firstName.$error) errors.push(`First name ${v$.firstName.$errors[0].$message.toLowerCase()}`)
    if(v$.lastName.$error) errors.push(`Last name ${v$.lastName.$errors[0].$message.toLowerCase()}`)
    if(v$.email.$error) errors.push(`${emailPrefix ? '' : 'Email'} ${emailPrefix ? emailError : emailError.toLowerCase()}`)
    if(v$.company.$error) errors.push(`Company ${v$.company.$errors[0].$message.toLowerCase()}`)
    if(v$.industry.$error) errors.push(`Industry ${v$.industry.$errors[0].$message.toLowerCase()}`)
    if(v$.city.$error) errors.push(`City ${v$.city.$errors[0].$message.toLowerCase()}`)
    if(v$.state.$error) errors.push(`State ${v$.state.$errors[0].$message.toLowerCase()}`)
    if(v$.country.$error) errors.push(`Country ${v$.country.$errors[0].$message.toLowerCase()}`)

    return errors.length !== 0 ? errors : null
}

export const defineCareersFormError = (v$) => {
  const errors = [];
  const emailPrefix = v$.email.$errors[0]?.$message.split(' ')[0].toLowerCase() === 'invalid'
  const emailError = v$.email.$errors[0]?.$message

  if(v$.firstName.$error) errors.push(`First name ${v$.firstName.$errors[0].$message.toLowerCase()}`)
  if(v$.lastName.$error) errors.push(`Last name ${v$.lastName.$errors[0].$message.toLowerCase()}`)
  if(v$.email.$error) errors.push(`${emailPrefix ? '' : 'Email'} ${emailPrefix ? emailError : emailError.toLowerCase()}`)
  if(v$.attachment.$error) errors.push(`Resume ${v$.attachment.$errors[0].$message.toLowerCase()}`)

  return errors.length !== 0 ? errors : null
}

export const formatPhoneNumber = (str) => {
    const numberStr = str.replace(/\D/g, '');
    let formattedNumber = '';

    if (numberStr.length > 0) {
        formattedNumber = numberStr.substring(0, 3);
    }
    if (numberStr.length > 3) {
        formattedNumber += '-' + numberStr.substring(3, 6);
    }
    if (numberStr.length > 6) {
        formattedNumber += '-' + numberStr.substring(6, 10);
    }

    return formattedNumber;
}
